import React from 'react';
import Login from '../../../Components/Login/Login';

const UserLoginPage = () => {
    return (
        <div>
            <Login></Login>
        </div>
    );
};

export default UserLoginPage;